import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar'
import { useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import PessoasService from '../../services/database/PessoasService'
import { CustomSpinner } from '../../components/CustomSpinner'
import { formatPrice } from '../../utils/formatPrice'
import { CustomButton } from '../../components/CustomButton'
import {
  ArrowClockwise,
  CaretDown,
  CaretUp,
  ClockHistory,
  Coin,
  EyeFill,
  Search,
  TruckFlatbed,
} from 'react-bootstrap-icons'
import { ModalConsultarSaldo } from './ModalConsultarSaldo'
import NoFoundPeopleSvg from '../../assets/illustration/no-found-people.svg'
import ReactPaginate from 'react-paginate'

import { useOrderTable } from '../../hooks/useOrderTable'
import { ModalModificarSaldo } from './ModalModificarSaldo'
import { ModalHistoricoSaldo } from './ModalHistoricoSaldo'

import './styles.css'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function ConsultarSaldo() {
  const [pessoas, setPessoas] = useState([])
  const [isLoadingPessoas, setIsLoadingPessoas] = useState(true)
  const [search, setSearch] = useState('')

  const [modalConsultarIsOpen, setModalConsultarIsOpen] = useState(false)
  const [modalModificarIsOpen, setModalModificarIsOpen] = useState(false)
  const [modalHistoricoIsOpen, setModalHistoricoIsOpen] = useState(false)

  const [selectedPessoa, setSelectedPessoa] = useState()

  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage] = useState(10)

  const endOffset = itemOffset + itemsPerPage
  const pageCount = Math.ceil(pessoas.length / itemsPerPage)

  const {
    sortedArray: sortedSaldo,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(pessoas, 'saldo_atual')

  const currentPeople = useMemo(() => {
    return sortedSaldo.slice(itemOffset, endOffset)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endOffset, itemOffset, sortedSaldo, orderType.field, orderType.type])

  const modalModificarSaldoRef = useRef(null)
  const modalHistoricoSaldoRef = useRef(null)

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % pessoas.length

    setItemOffset(newOffset)
  }

  function handleModalModificarClose() {
    setModalModificarIsOpen(false)
  }

  function handleModalHistoricoClose() {
    setModalHistoricoIsOpen(false)
  }

  function handleModalClose() {
    setModalConsultarIsOpen(false)
  }

  async function loadPessoas() {
    setIsLoadingPessoas(true)

    try {
      const pessoasData = await PessoasService.getAll(true)

      setPessoas(pessoasData)
    } catch (error) {
      console.log(`Erro ao listar as pessoas com saldo:`, error)
      toast.error('Erro ao listar as pessoas com saldo!')
    } finally {
      setIsLoadingPessoas(false)
    }
  }

  async function handleSearch() {
    try {
      setIsLoadingPessoas(true)

      const pessoasData = await PessoasService.getBySearch({ search })

      setPessoas(pessoasData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível a pesquisa por clientes!')
    } finally {
      setIsLoadingPessoas(false)
    }
  }

  useEffect(() => {
    loadPessoas()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Consultar Saldo dos Clientes</h1>

        <Row>
          <Col>
            <Form.Control
              placeholder="Pesquise pelo nome..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (e.target.value.length > 0) {
                    handleSearch()
                  }
                }
              }}
            />
          </Col>

          <Col
            style={{
              display: 'flex',
            }}
          >
            <CustomButton
              title="Pesquisar"
              onClick={handleSearch}
              isLoading={isLoadingPessoas}
              isLoadingText="Pesquisando..."
              isDisabled={search.length === 0}
            >
              <Search />
            </CustomButton>

            <CustomButton
              color="#b019ed"
              title="Recarregar"
              onClick={loadPessoas}
              isLoading={isLoadingPessoas}
              isLoadingText="Recarregando..."
            >
              <ArrowClockwise />
            </CustomButton>
          </Col>
        </Row>

        {isLoadingPessoas ? (
          <div
            style={{
              display: 'flex',
              height: '300px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CustomSpinner color="#006fff" />
          </div>
        ) : !isLoadingPessoas && pessoas.length === 0 ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <h1>Sem dados á serem exibidos :(</h1>
            </div>

            <img
              src={NoFoundPeopleSvg}
              style={{
                width: 450,
              }}
            />
          </div>
        ) : (
          <Table
            striped
            bordered
            hover
          >
            <thead>
              <tr>
                <th onClick={() => handleOrganize('cod_pessoa')}>
                  <span>ID</span>

                  <CaretUp color={check('cod_pessoa', 'asc')} />
                  <CaretDown color={check('cod_pessoa', 'desc')} />
                </th>
                <th onClick={() => handleOrganize('pes_razao')}>
                  <span>Nome</span>

                  <CaretUp color={check('pes_razao', 'asc')} />
                  <CaretDown color={check('pes_razao', 'desc')} />
                </th>
                <th onClick={() => handleOrganize('saldo_atual')}>
                  <span>Saldo Atual</span>

                  <CaretUp color={check('saldo_atual', 'asc')} />
                  <CaretDown color={check('saldo_atual', 'desc')} />
                </th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {currentPeople.map((pessoa) => (
                <tr key={pessoa.cod_pessoa}>
                  <td>{pessoa.cod_pessoa}</td>
                  <td>{pessoa.pes_razao}</td>
                  <td>{formatPrice(pessoa?.saldo_atual) || 0}</td>
                  <td
                    style={{
                      display: 'flex',
                    }}
                  >
                    <OverlayTrigger
                      overlay={<Tooltip>Consultar Movimentação</Tooltip>}
                    >
                      <CustomButton
                        color="#8A2BE2"
                        onClick={() => {
                          setSelectedPessoa(pessoa)
                          setModalConsultarIsOpen(TruckFlatbed)
                        }}
                      >
                        <EyeFill />
                      </CustomButton>
                    </OverlayTrigger>

                    <OverlayTrigger
                      overlay={<Tooltip>Modificar Saldo</Tooltip>}
                    >
                      <CustomButton
                        color="#ea8d0d"
                        onClick={() => {
                          setSelectedPessoa(pessoa)
                          setModalModificarIsOpen(true)
                        }}
                      >
                        <Coin />
                      </CustomButton>
                    </OverlayTrigger>

                    <OverlayTrigger
                      overlay={<Tooltip>Consultar Histórico de Saldo</Tooltip>}
                    >
                      <CustomButton
                        color="#4169E1"
                        onClick={() => {
                          setSelectedPessoa(pessoa)
                          setModalHistoricoIsOpen(true)
                        }}
                      >
                        <ClockHistory />
                      </CustomButton>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <ReactPaginate
          breakLabel="..."
          nextLabel="Próxima"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="Anterior"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          activeClassName="active"
        />
      </div>

      {modalConsultarIsOpen && (
        <ModalConsultarSaldo
          isOpen={modalConsultarIsOpen}
          pessoa={selectedPessoa}
          onClose={handleModalClose}
        />
      )}

      {modalModificarIsOpen && (
        <ModalModificarSaldo
          ref={modalModificarSaldoRef}
          pessoa={selectedPessoa}
          loadPessoas={loadPessoas}
          isOpen={modalModificarIsOpen}
          onClose={handleModalModificarClose}
        />
      )}

      {modalHistoricoIsOpen && (
        <ModalHistoricoSaldo
          ref={modalHistoricoSaldoRef}
          pessoa={selectedPessoa}
          isOpen={modalHistoricoIsOpen}
          onClose={handleModalHistoricoClose}
        />
      )}
    </>
  )
}
